<script>
import AdminLayout from '@layouts/admin-main'
import CertificationList from '@components/admin/kyc-certification-list'

export default {
  page: {
    title: 'Admin::KycCertificationList',
    meta: [{ name: 'description', content: 'Admin::KycCertificationList' }],
  },
  components: { AdminLayout, CertificationList },
}
</script>

<template>
  <AdminLayout>
    <CertificationList></CertificationList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
